module.exports = __webpack_public_path__ + "static/media/about.dc309339.jpg";